import { Type } from '@sinclair/typebox';
export const UseFiltersSchema = Type.Boolean({ default: true });
export const AttributeValueSingleSchema = Type.Union([Type.Number(), Type.Boolean(), Type.String()]);
export const AttributeValueMultiSchema = Type.Array(AttributeValueSingleSchema);
export const AttributeValueSchema = Type.Union([AttributeValueSingleSchema, AttributeValueMultiSchema]);
export const AttributesSchema = Type.Record(Type.String(), AttributeValueSchema);
export const FamilyNameSchema = Type.String({
    minLength: 1,
});
export const ProductNameSchema = Type.String({
    minLength: 1,
});
export const ProductItemSchema = Type.Object({
    productFamilyName: FamilyNameSchema,
    productName: ProductNameSchema,
    attributes: AttributesSchema,
    sku: Type.Optional(Type.String()),
});
export const currencySchema = Type.String({
    minLength: 3,
    maxLength: 3,
    examples: ['USD'],
});
//# sourceMappingURL=shared.js.map